export default __webpack_public_path__ + "static/bg-tax-b6711d6cade10bfae45db6baf5e60e92.jpg";